import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import ArrowDropDownRounded from '@src/assets/icons/ArrowDropDownRounded.svg';
import CustomSelect from '@src/components/CustomSelect';
import { useClickOutside } from '@src/hooks/useClickOutSide';
import { StyledPhoneInput } from './index.style';
import CommonInput from '../CommonInput';

const PhoneInput = ({
  defaultCodeCountry,
  countryCodes,
  showCountryCode,
  currentOption,
  setCurrentOption,
  ...props
}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownEl = useClickOutside(() => {
    setShowDropdown(false);
  });
  useEffect(() => {
    if (defaultCodeCountry) {
      setCurrentOption(defaultCodeCountry);
    }
  }, [defaultCodeCountry]);

  const changeHandler = (option) => {
    setCurrentOption(option);
  };

  const renderStartAdornment = () => (
    <Box
      onClick={() => setShowDropdown(!showDropdown)}
      className="select-btn-phone-country"
    >
      {currentOption?.dialCode}
      <img src={ArrowDropDownRounded} alt="" />
    </Box>
  );
  return (
    <StyledPhoneInput ref={dropdownEl}>
      <CommonInput
        sx={{
          '& .MuiOutlinedInput-root': {
            padding: '0',
            overflow: 'hidden',
          },
        }}
        {...props}
        startAdornment={showCountryCode ? renderStartAdornment() : null}
      />
      {showDropdown && (
        <div className="select-custom">
          <CustomSelect
            showDropdown={showDropdown}
            onSetShowDropdown={setShowDropdown}
            data={countryCodes}
            currentOption={currentOption}
            onChange={changeHandler}
          />
        </div>
      )}
    </StyledPhoneInput>
  );
};

export default PhoneInput;
